import { useEffect, useState } from "react";
import { CardArtPlaceholder } from "./CardArtPlaceholder";
import { CardSyntheticFace } from "./CardSyntheticFace";

/**
 * Detail modal: full RingsDB asset at natural aspect ratio when the URL loads.
 * Falls back to a synthetic card face (or framed placeholder) when the link errors.
 */
export function CardDetailArt({ src, alt, card }) {
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    setLoadFailed(false);
  }, [src]);

  if (loadFailed) {
    return card ? (
      <CardSyntheticFace card={card} variant="detail" />
    ) : (
      <CardArtPlaceholder variant="detail" reason="broken" />
    );
  }

  return (
    <div className="mx-auto w-full max-w-sm overflow-hidden rounded-lg border border-slate-700 bg-slate-950">
      <img
        src={src}
        alt={alt}
        referrerPolicy="no-referrer"
        decoding="async"
        className="block h-auto w-full max-w-none"
        onError={() => setLoadFailed(true)}
      />
    </div>
  );
}
